/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import List from '@ckeditor/ckeditor5-list/src/list';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import { icons } from 'ckeditor5/src/core';
export default class AI extends Plugin {
	init() {
		const editor = this.editor;
// @ts-ignore
		editor.ui.componentFactory.add( 'ai', () => {
			// The button will be an instance of ButtonView.
			const button = new ButtonView();

			button.set( {
				label: '',
			 	  icon:'<svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
					  '\t viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;width:18px;height:18px" xml:space="preserve">\n' +
					  '<style type="text/css">\n' +
					  '\t.st0{fill:#005FFF;}\n' +
					  '\t.st1{fill:url(#SVGID_1_);}\n' +
					  '\t.st2{fill:#FFFFFF;}\n' +
					  '</style>\n' +
					  '<g>\n' +
					  '\t<g>\n' +
					  '\t\t<g>\n' +
					  '\t\t\t\n' +
					  '\t\t\t\t<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="0.8732" y1="2.7444" x2="15.1423" y2="17.0134" gradientTransform="matrix(1 0 0 -1 0 18)">\n' +
					  '\t\t\t\t<stop  offset="0" style="stop-color:#2E85FA"/>\n' +
					  '\t\t\t\t<stop  offset="1" style="stop-color:#AD76FF"/>\n' +
					  '\t\t\t</linearGradient>\n' +
					  '\t\t\t<path class="st1" d="M15.9,5.9l-1.5-2.1l0.8-2.4c0.1-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.3-0.2-0.5-0.1l-2.4,0.8l-2.1-1.5\n' +
					  '\t\t\t\tC10,0,9.8,0,9.6,0.1C9.4,0.1,9.3,0.3,9.3,0.5l0,2.6L7.3,4.5C7.1,4.6,7.1,4.8,7.1,5c0,0.2,0.2,0.3,0.3,0.4l2.5,0.8l0.8,2.5\n' +
					  '\t\t\t\tc0.1,0.2,0.2,0.3,0.5,0.3c0.2,0,0.3-0.1,0.4-0.2l1.5-2.1l2.6,0c0.2,0,0.3-0.1,0.4-0.3C16,6.2,16,6,15.9,5.9L15.9,5.9z M15.5,9.8\n' +
					  '\t\t\t\tl-1-0.1l-0.4-0.9c-0.2-0.3-0.7-0.3-0.8,0l-0.4,0.9l-1,0.1c-0.2,0-0.3,0.2-0.4,0.3c-0.1,0.2,0,0.4,0.1,0.5l0.7,0.7l-0.2,1\n' +
					  '\t\t\t\tc0,0.2,0,0.4,0.2,0.5c0.1,0.1,0.3,0.1,0.5,0l0.9-0.5l0.9,0.5c0.2,0.1,0.4,0.1,0.5,0c0.1-0.1,0.2-0.3,0.2-0.5l-0.2-1l0.7-0.7\n' +
					  '\t\t\t\tc0.1-0.1,0.2-0.3,0.1-0.5C15.8,10,15.7,9.8,15.5,9.8L15.5,9.8z M3.7,2.8l-0.2,1c0,0.2,0,0.4,0.2,0.5c0.1,0.1,0.3,0.1,0.5,0\n' +
					  '\t\t\t\tl0.9-0.5L6,4.3c0.2,0.1,0.4,0.1,0.5,0C6.7,4.2,6.7,4,6.7,3.8l-0.2-1l0.7-0.7C7.4,2,7.4,1.8,7.4,1.6C7.3,1.5,7.2,1.3,7,1.3L6,1.2\n' +
					  '\t\t\t\tL5.6,0.3c-0.2-0.3-0.7-0.3-0.8,0L4.3,1.2l-1,0.1c-0.2,0-0.3,0.2-0.4,0.3C2.8,1.8,2.9,2,3,2.1L3.7,2.8z M9.1,6.9L7.6,6.4l-7.4,7.4\n' +
					  '\t\t\t\tC0,14,0,14.3,0.1,14.5l1.3,1.3C1.6,16,1.7,16,1.8,16s0.2,0,0.3-0.1l7.4-7.4L9.1,6.9z"/>\n' +
					  '\t\t</g>\n' +
					  '\t</g>\n' +
					  '</g>\n' +
					  '</svg>\n',
				withText: true,
				class:'ck-ai-button'
			} );

			//Execute a callback function when the button is clicked
			button.on('execute', () => {
				const model = this.editor.model;
				const now = new Date().getTime();
				// @ts-ignore
				openAI(now,model,this.editor)
			} );

			return button;
		} );
	}
}

